__turbopack_context__.v({
  "root": "switch-module__Uis08q__root",
  "thumb": "switch-module__Uis08q__thumb",
});
